var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.506 9.31847L7 7.68433L4.494 9.31847L5.25 6.39123L2.947 4.4871L5.922 4.30237L7 1.50301L8.078 4.30237L11.053 4.4871L8.75 6.39123L9.506 9.31847ZM12.6 5.90809C12.6 5.11944 13.23 4.4871 14 4.4871V1.64511C14 0.856463 13.37 0.224121 12.6 0.224121H1.4C1.0287 0.224121 0.672601 0.373832 0.41005 0.64032C0.1475 0.906808 0 1.26824 0 1.64511V4.4871C0.777 4.4871 1.4 5.12655 1.4 5.90809C1.4 6.28496 1.2525 6.6464 0.98995 6.91289C0.727399 7.17937 0.371303 7.32908 0 7.32908V10.1711C0 10.5479 0.1475 10.9094 0.41005 11.1759C0.672601 11.4424 1.0287 11.5921 1.4 11.5921H12.6C12.9713 11.5921 13.3274 11.4424 13.5899 11.1759C13.8525 10.9094 14 10.5479 14 10.1711V7.32908C13.6287 7.32908 13.2726 7.17937 13.0101 6.91289C12.7475 6.6464 12.6 6.28496 12.6 5.90809Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickets);
export default __webpack_public_path__ + "static/media/tickets.1256229a.svg";
export { ForwardRef as ReactComponent };